// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Loading from './loading';

// Styles
import './thumbnail.scss';

class Thumbnail extends Component {
    state = {
        loaded: false,
    };

    componentDidUpdate(nextProps) {
        const {src} = this.props;

        if (src !== nextProps.src) {
            this.setState({loaded: false});
        }
    }

    getClass() {
        const {className} = this.props;

        return classnames(
            {
                'thumbnail--container': true,
            },
            className
        );
    }

    getProps() {
        const {maxWidth = 100, src, width} = this.props;

        return {
            className: 'thumbnail--image',
            onError: this.handleLoad,
            onLoad: this.handleLoad,
            src,
            style: {
                width: width && width < maxWidth ? width : maxWidth,
            },
        };
    }

    handleLoad = () => {
        this.setState({loaded: true});
    };

    render() {
        const {label, loading: loadingProp, title} = this.props;
        const {loaded} = this.state;
        const loading = !loaded || loadingProp;

        return (
            <div className={this.getClass()} title={title}>
                <img alt="Thumbnail" {...this.getProps()} />
                {label ? <label className="thumbnail--label">{label}</label> : null}
                <Loading className="thumbnail--loading" loading={loading} small={true} />
            </div>
        );
    }
}

Thumbnail.propTypes = {
    className: PropTypes.string,
    height: PropTypes.number,
    label: PropTypes.string,
    loading: PropTypes.bool,
    maxWidth: PropTypes.number,
    src: PropTypes.string.isRequired,
    title: PropTypes.string,
    width: PropTypes.number,
};

export default Thumbnail;
